var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { Link } from 'react-router-dom';

export function splitPathnameAndQueryString(path) {
  var _path$split = path.split('?'),
      pathname = _path$split[0],
      search = _path$split[1];

  return {
    pathname: pathname,
    search: search ? '?' + search : ''
  };
}

function addModalStateToLink(to) {
  if (typeof to === 'string') {
    var _splitPathnameAndQuer = splitPathnameAndQueryString(to),
        pathname = _splitPathnameAndQuer.pathname,
        search = _splitPathnameAndQuer.search;

    return {
      pathname: pathname,
      search: search,
      state: {
        modal: true
      }
    };
  } else {
    return _extends({}, to, {
      state: _extends({}, to.state, {
        modal: true
      })
    });
  }
}

function ModalLink(_ref) {
  var to = _ref.to,
      rest = _objectWithoutProperties(_ref, ['to']);

  return React.createElement(Link, _extends({}, rest, { to: addModalStateToLink(to) }));
}

ModalLink.propTypes = process.env.NODE_ENV !== "production" ? Link.propTypes : {};

export default ModalLink;